import UnauthorizedScreen from '../features/session/layouts/unauthorized-screen';

export default function UnauthorizedPage() {
    return <UnauthorizedScreen />;
}
